export default "__VITE_ASSET__IAGV2_S7__"